import React from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { useHistory, Link, useLocation, useRouteMatch } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import styled from "styled-components";

import AuthActions from "../actions/auth.actions";
import { ReactComponent as Logout } from "../assets/imgs/Logout.svg";
import { ReactComponent as Account } from "../assets/imgs/Account.svg";
import { ReactComponent as Profile } from "../assets/imgs/Profile.svg";
import { ReactComponent as Campaigns } from "../assets/imgs/Campaign.svg";

const drawerWidth = 200;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: "#3F3F3F",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: "#fff",
    marginTop: "100px",
    borderRadius: "7px",
    marginBottom: "20px",
  },
}));

const StyledHeader = styled(AppBar)`
  color: black;
  background-color: #fff;
`;

const NotAuthProfile = [
  {
    label: "Profile",
    key: "/profile",
  },
];

function ResponsiveDrawer(props) {
  let location = useLocation();
  let history = useHistory();
  const profile = useSelector((state) => state.companyProfile.profile); // acts like a mapStateToProps, get a profile state as a prop 
  const NoProfile = useSelector((state) => state.companyProfile.profile); // ? 
  
  const AuthProfile = [
    { 
      label: "Profile",
      key: "/profile",
      show: true
    },
    {
      label: "Campaigns",
      key: "/campaigns",
      img: Campaigns,
      show: props.IsProfileCreated
    }
    // {
    //   label: "Account",
    //   key: "/account",
    //   img: Account,
    // }
  ];

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false); 

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  var pageTitle = "";
  if (props.label) {
    pageTitle = props.label;
  } else {
    const matchingObject = [
      {
        label: "Profile",
        key: "/profile",
      },
      {
        label: "Campaigns",
        key: "/campaigns",
      },
      {
        label: "Account",
        key: "/account",
      },
      {
        label: "New Campaign",
        key: "/campaign/new",
      },
    ].find((obj) => obj.key === location.pathname);
    pageTitle = matchingObject ? matchingObject.label : "";
  }
  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <Link
          to="/"
          style={{
            textAlign: "center",
            lineHeight: "64px",
            display: "block",
            textDecoration: "none",
            fontWeight: "bold",
            color: "#fff",
            fontSize: "20px",
          }}
        >
          Mystery<span style={{ color: "#00FFFF" }}>QR</span>
        </Link>
      </div>
      <Divider />
      <List style={{ marginTop: "20px" }}>
        {AuthProfile.filter(obj=>obj.show).map(
          (obj, index) => {
            const style =
              location.pathname === obj.key
                ? {
                    color: "#00ffff",
                    background: "#525252",
                    margin: "auto",
                    width: "90%",
                    borderRadius: "7px",
                  }
                : {
                    color: "#fff",
                    margin: "auto",
                    width: "90%",
                    borderRadius: "7px",
                  };
            var Icon = {
              Profile: Profile,
              Campaigns: Campaigns,
              Account: Account,
            }[obj.label];
            if (location.pathname === obj.key) {
              Icon = styled(Icon)`
                #Desktop {
                  fill: #00ffff;
                }
              `;
            }
            return (
              <ListItem
                button
                key={obj.label}
                onClick={() => history.push(obj.key)} // on click sends to a new path . 
                style={style}
              >
                <Icon style={{ height: "25px", paddingRight: "10px" }} />
                <ListItemText primary={obj.label} />
              </ListItem>
            );
          }
        )}  
        {
          props.IsProfileCreated &&
          <ListItem
            style={{
              color: "#00ffff",
              // background: "#525252",
              margin: "auto",
              width: "90%",
              borderRadius: "7px",
            }}
          >
            <a
              href={`${process.env.REACT_APP_API_ENDPOINT}/api/v1/company/${profile.brandSlug}/redemption-qrcode`}
              style={{ color: "white", textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              Redemption QRCode
            </a>
          </ListItem>
        }
      </List>
      <Divider
        style={{ position: "absolute", bottom: "80px", left: 0, right: 0 }}
      />
      <List style={{ position: "absolute", bottom: "10px", left: 0, right: 0 }}>
        {["Logout"].map((text, index) => (
          <ListItem
            button
            key={text}
            style={{
              color: "#fff",
              margin: "auto",
              width: "90%",
              borderRadius: "7px",
            }}
            onClick={() => props.logoutUser()}
          >
            <Logout style={{ height: "25px", paddingRight: "10px" }}></Logout>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <StyledHeader position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {pageTitle}
          </Typography>
        </Toolbar>
      </StyledHeader>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>{props.children}</main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default connect(null, (dispatch) => {
  return {
    logoutUser: () => dispatch(AuthActions.logoutUser()),
  };
})(ResponsiveDrawer);
